import { SessionManager } from "@codedrops/lib";

const sessionManager = new SessionManager({ key: "notebase" });

export default sessionManager;
